var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteNewStyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5707 7.13302L15.7828 10.494C15.1074 13.3966 13.7726 14.5705 11.264 14.3293C10.862 14.2972 10.4278 14.2248 9.96143 14.1122L8.61062 13.7906C5.25772 12.9946 4.22049 11.3382 5.00846 7.97728L5.79643 4.60829C5.95724 3.92485 6.15022 3.32984 6.39143 2.83937C7.33217 0.893558 8.93224 0.370923 11.6178 1.00613L12.9605 1.31971C16.3295 2.10768 17.3587 3.77207 16.5707 7.13302Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2622 14.3288C10.7637 14.6665 10.1365 14.9479 9.37267 15.1972L8.10227 15.6153C4.91018 16.6445 3.22971 15.7841 2.19248 12.5921L1.16329 9.41604C0.134106 6.22394 0.986402 4.53542 4.17849 3.50623L5.44889 3.08812C5.77856 2.9836 6.09214 2.89515 6.38964 2.83887C6.14842 3.32934 5.95545 3.92434 5.79464 4.60779L5.00667 7.97678C4.21869 11.3377 5.25592 12.9941 8.60882 13.7901L9.95963 14.1117C10.426 14.2243 10.8602 14.2966 11.2622 14.3288Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31982 5.59668L13.2195 6.58567",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53052 8.70898L10.8623 9.30399",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteNewStyle);
export default __webpack_public_path__ + "static/media/noteNewStyle.af06302a1a455935b91958c146b03d95.svg";
export { ForwardRef as ReactComponent };